module.exports = __webpack_public_path__ + "img/withdrawal-bg.ee9d6de7.svg";